import type { API } from '@setplex/tria-api'

import { sample } from 'effector'
import * as observed from '../observe'

export function use(api: API) {
  const http = api.events.http

  sample({
    clock: observed.request,
    target: http.request,
  })

  sample({
    clock: observed.response,
    target: http.response,
  })

  sample({
    clock: observed.error,
    target: http.error,
  })
}
